import { env } from './env'

//console.log(env)

const config = {
    hubUrl: env.REACT_APP_ENDPOINTS__HUB,
    hubUrlextern: env.REACT_APP_ENDPOINTS__HUBEXTERN,
    downloadUrlLog: env.REACT_APP_ENDPOINTS__DOWNLOADLOG,
    downloadUrlSnapShot: env.REACT_APP_ENDPOINTS__SNAPSHOT,
    downloadUrlZip: env.REACT_APP_ENDPOINTS__DLZIP,
  };

export default config;